import DocumentRequirement from '../DocumentRequirement';
import { TGetProductOffersResponseData } from '../TradingHistory';

type TProps = {
    isOptional: boolean;
    isSubmitted: boolean;
    status?: TGetProductOffersResponseData['products'][number]['data_requirements'][number]['status'];
};
const BusinessPlan = ({ isOptional, status }: TProps) => {
    return (
        <DocumentRequirement
            title="Business plan"
            documentType="business plan"
            isOptional={isOptional}
            status={status}
        >
            <>
                <p>Include information on:</p>
                <ul>
                    <li>The business you are proposing</li>
                    <li>How you plan on generating revenue</li>
                    <li>The size of investment you need</li>
                    <li>How the funds will be used</li>
                    <li>Details of your experience in the industry</li>
                </ul>
            </>
        </DocumentRequirement>
    );
};

// eslint-disable-next-line import/no-default-export
export default BusinessPlan;
